export default "__VITE_ASSET__DKRAP96w__"